import { gql } from "urql";
export const GetMeQuery = gql `
    query GetMe {
        users {
            me {
                id: userId
                organizationId
                masqueradeOrganizationId
                roleName
                name
                email
                permissions
                imageUrl
                acceptedTermsConditionsAt
                isActive
                organization {
                    organizationId
                    organizationTypes
                }
            }
        }
    }
`;
// Drives pickers that need to find a teammate by name/email. Defaults
// align with picker UX: active users only, alphabetical (server-side),
// capped at 100 per request. Callers pass a search string that the
// server applies across first/last/full name, email, and phone.
export const GetActiveUsersQuery = gql `
    query GetActiveUsers($search: String) {
        users {
            users(isActive: true, search: $search) {
                userId
                name
                imageUrl
                email
            }
        }
    }
`;
// Fetches a single user's full profile for the Team Drawer edit form,
// including org membership fields (locations, therapy, availability, etc.)
// that the list query doesn't return.
export const GetTeamMemberQuery = gql `
    query GetTeamMember($userId: String!) {
        users {
            user(userId: $userId) {
                userId
                firstName
                lastName
                email
                phoneNumber
                imageKey
                imageVersion
                imageUrl
                isActive
                roleName
                daysAvailable
                about
                notes
                educationAndCertifications
                preferredAges
                locations {
                    locationId
                    name
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                therapySubCategories {
                    therapySubCategoryId
                    name
                }
                patients {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                    daysAvailable
                    postalCode
                    gradeLevel
                    isActive
                    createdAt
                    postalCodeInfo {
                        stateId
                        city
                    }
                }
            }
        }
    }
`;
export const GetTeamMembersQuery = gql `
    query GetTeamMembers(
        $search: String
        $offset: Int
        $roleNames: [UserRoleEnum!]
        $isActive: Boolean
        $locationIds: [String]
        $includeTotalCount: Boolean!
    ) {
        users {
            users(
                search: $search
                offset: $offset
                roleNames: $roleNames
                isActive: $isActive
                locationIds: $locationIds
            ) {
                userId
                firstName
                lastName
                email
                phoneNumber
                imageUrl
                isActive
                roleName
                daysAvailable
                locations {
                    locationId
                    name
                    address1
                    city
                    stateId
                }
            }
            userCount(
                search: $search
                roleNames: $roleNames
                isActive: $isActive
                locationIds: $locationIds
            ) @include(if: $includeTotalCount)
        }
    }
`;
